import {
  USER_STORES_REQUEST,
  USER_STORES_REQUEST_FAILED,
  USER_STORES_REQUEST_SUCCEED,
} from "../actions/app";

const initialState = {
  inProgress: false,
  data: [],
};

export const userStoresAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_STORES_REQUEST:
      return { ...state, inProgress: true, data: [] };
    case USER_STORES_REQUEST_SUCCEED:
      return { ...state, inProgress: false, data: action.payload };
    case USER_STORES_REQUEST_FAILED:
      return { ...state, inProgress: false, error: action.payload };
    default:
      return state;
  }
};
